<template>
  <Modal ref="modalRef" :show="show" @close="closeModal" :modal-size="modalSize">
    <template #header>
      <span class="fond-bold text-lg">{{ title }}</span>
    </template>

    <template #body>
      <p class="primary-text" v-html="message"></p>
    </template>

    <template #footer>
      <button class="secondary-btn mx-2 text-sm" @click="handleCancel">
        {{ cancelText }}
      </button>
      <button class="primary-btn text-sm" @click="handleConfirm">
        {{ confirmText }}
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from "./Modal.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { computed } from "vue";


const show = ref(false);

const { t } = useI18n();
const message = ref<string>("");
const title = ref<string>(t("Common.pleaseConfirm"));
const modalSize = ref<string>("sm:w-full sm:max-w-sm sm:p-6");

const props = defineProps<{
  confirmText?: string;
  cancelText?: string;
}>();

const openModal = () => {
  show.value = true;
};
const closeModal = () => {
  show.value = false;
};

const confirmText = computed(() => {
  return props.confirmText || t("Common.confirm");
});

const cancelText = computed(() => {
  return props.cancelText || t("Common.cancel");
});
let myResolve: (value: boolean | PromiseLike<boolean>) => void;

const confirm = (msg: string, ttl?: string): Promise<boolean> => {
  message.value = msg;
  if (!ttl) {
    ttl = t("Common.pleaseConfirm");
  }
  title.value = ttl;
  openModal();
  return new Promise((resolve) => {
    myResolve = resolve;
  });
};

const handleCancel = () => {
  closeModal();
  myResolve(false);
};

const handleConfirm = () => {
  closeModal();
  myResolve(true);
};

defineExpose({
  confirm,
});
</script>
